// dependency-graph-ignore-file
import { type Database } from '@databases/model/database';

export function setIsMulti(ydb: Database, fieldId: string, isMulti: boolean): void {
  ydb.mutate((db) => {
    const field = db.fieldsById[fieldId];

    field.multi = isMulti;
  });
}
